var render = function render(){var _vm=this,_c=_vm._self._c;return _c(_vm.type,_vm._b({ref:"input",tag:"component",staticClass:"percentage-input",attrs:{"step":_vm.step,"min":_vm.min,"max":_vm.max,"type":"number"},model:{value:(_vm.percent),callback:function ($$v) {_vm.percent=$$v},expression:"percent"}},'component',_vm.$attrs,false),[_vm._t("append",null,{"slot":"append"})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }